import { Civil3dPropertyApiModel } from './civil3d-property.model';

export type Civil3dPropertySetApiModel = {
  id: number;
  name: string;
};

export type WithCivil3dProperties = Civil3dPropertySetApiModel & { properties: Civil3dPropertyApiModel[] };

export enum Civil3dPropertySetRelationship {
  PROPERTIES = 'PROPERTIES',
}
